var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container text-center mt-5 mb-5"},[_c('h1',[_vm._v(_vm._s(_vm.$t(_vm.LangConstants.not_found_page_text)))])])}
var staticRenderFns = []

export { render, staticRenderFns }